import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authApi } from "./Reducer/auth";
import userReducer from "./slices/userSlice";
import AiMessagesReducer from "./slices/aiMessages";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { additionalServicesApi } from "./Reducer/admin-additional-services";
import { adminAuthApi } from "./Reducer/admin-auth";
import { adminContractorsApi } from "./Reducer/admin-contractors";
import { geographicAdjusterApi } from "./Reducer/admin-geographic-adjuster";
import { jobTypeApi } from "./Reducer/admin-job-type";
import { adminServicesApi } from "./Reducer/admin-services-api";
import { adminTermsApi } from "./Reducer/admin-terms";
import { invoiceApi } from "./Reducer/invoice";
import { transactionApi } from "./Reducer/transaction";
import { jobsApi } from "./Reducer/jobs";
import { jobTypesApi } from "./Reducer/job-types";
import { reminderSettingsApi } from "./Reducer/reminder-settings";
import { estimatorSettingApi } from "./Reducer/estimator-setting";
import { contractorSettingsApi } from "./Reducer/contractor-setting";
import { courseCategoryApi } from "./Reducer/course-category";
import { courseApi } from "./Reducer/course";
import { lessonApi } from "./Reducer/lesson";
import { supportCenterCategoryApi } from "./Reducer/supportCenter-category";
import { resourceApi } from "./Reducer/resource";
import { resourcePackageApi } from "./Reducer/resource-package";
import { invoiceNoteApi } from "./Reducer/invoice-note";
import { adminSettingsApi } from "./Reducer/adminSetting";
import { adminSupportApi } from "./Reducer/adminSupport";
import { aiAssistantApi } from "./Reducer/ai-assistant";
import { alertApi } from "./Reducer/alert";
import { BuildModeApi } from "./Reducer/build-mode";
import { BuildStageApi } from "./Reducer/build-stage";
import { categoryApi } from "./Reducer/category";
import { ClientApi } from "./Reducer/client";
import { contactApi } from "./Reducer/contact";
import { contractorAuthApi } from "./Reducer/contractorAuth";
import { contractorDashboardApi } from "./Reducer/contractortDashboard";
import { customersApi } from "./Reducer/customers";
import { customizePagesApi } from "./Reducer/customize-pages";
import { dashboardApi } from "./Reducer/dashboard";
import { estimateNoteApi } from "./Reducer/estimate-note";
import { estimateCategoryApi } from "./Reducer/estimate-category";
import supportCountsReducer from "../redux/supportCountsSlice";
import { estimatorTemplateApi } from "./Reducer/estimatorTemplate";
import { FaqsApi } from "./Reducer/faqs";
import { fileApi } from "./Reducer/file";
import { inventoryApi } from "./Reducer/inventory";
import { languageApi } from "./Reducer/languages";
import { metricApi } from "./Reducer/metric";
import { NotificationRules } from "./Reducer/notification-rules";
import { settingsApi } from "./Reducer/settings";
import { shopAdminApi } from "./Reducer/shop-admin";
import { ShopAdminDasbhoardApi } from "./Reducer/shop-admin-dashboard";
import { shopFloorDisplaySettingsApi } from "./Reducer/shop-floor-display-settings";
import { technicianApi } from "./Reducer/technician";
import { tilledApi } from "./Reducer/tilled";
import { usersApi } from "./Reducer/users";
import { MessageBoard } from "./Reducer/message-board";
import { adminManagementApi } from "./Reducer/admin-management";
import { adminAiChatApi } from "./Reducer/admin-ai-chat";

// Define the persist configuration
const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['user'],
};

const aiMessagesPersistConfig = {
  key: 'aiMessages',
  storage,
};


// Create a persisted reducer for the user slice
const persistedUserReducer = persistReducer(persistConfig, userReducer);
const persistedAiMessagesReducer = persistReducer(aiMessagesPersistConfig, AiMessagesReducer);

// Create the Redux store with the persisted reducer for the user slice
export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [contractorAuthApi.reducerPath]: contractorAuthApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [customersApi.reducerPath]: customersApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [FaqsApi.reducerPath]: FaqsApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer,
    [adminSettingsApi.reducerPath]: adminSettingsApi.reducer,
    [adminSupportApi.reducerPath]: adminSupportApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [languageApi.reducerPath]: languageApi.reducer,
    [contractorDashboardApi.reducerPath]: contractorDashboardApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [adminAuthApi.reducerPath]: adminAuthApi.reducer, 
    [settingsApi.reducerPath]: settingsApi.reducer,
    [technicianApi.reducerPath]: technicianApi.reducer,
    [inventoryApi.reducerPath]: inventoryApi.reducer,
    [estimatorTemplateApi.reducerPath]: estimatorTemplateApi.reducer,
    [metricApi.reducerPath]: metricApi.reducer,
    [ClientApi.reducerPath]: ClientApi.reducer,
    [adminContractorsApi.reducerPath]: adminContractorsApi.reducer, 
    [jobTypeApi.reducerPath]: jobTypeApi.reducer, 
    [adminServicesApi.reducerPath]: adminServicesApi.reducer,
    [additionalServicesApi.reducerPath]: additionalServicesApi.reducer,
    [adminTermsApi.reducerPath]: adminTermsApi.reducer,
    [geographicAdjusterApi.reducerPath]: geographicAdjusterApi.reducer,
    [invoiceApi.reducerPath]: invoiceApi.reducer,
    [transactionApi.reducerPath]: transactionApi.reducer,
    [jobsApi.reducerPath]: jobsApi.reducer,
    [jobTypesApi.reducerPath]: jobTypesApi.reducer,
    [reminderSettingsApi.reducerPath]: reminderSettingsApi.reducer, 
    [estimatorSettingApi.reducerPath]: estimatorSettingApi.reducer,
    [contractorSettingsApi.reducerPath]: contractorSettingsApi.reducer, 
    [courseCategoryApi.reducerPath]: courseCategoryApi.reducer,
    [courseApi.reducerPath]: courseApi.reducer,
    [lessonApi.reducerPath]: lessonApi.reducer,
    [supportCenterCategoryApi.reducerPath]: supportCenterCategoryApi.reducer,
    [resourceApi.reducerPath]: resourceApi.reducer,
    [resourcePackageApi.reducerPath]: resourcePackageApi.reducer,
    [alertApi.reducerPath]: alertApi.reducer,
    [invoiceNoteApi.reducerPath]: invoiceNoteApi.reducer,
    [aiAssistantApi.reducerPath]: aiAssistantApi.reducer, 
    [customizePagesApi.reducerPath]: customizePagesApi.reducer,
    [tilledApi.reducerPath]: tilledApi.reducer,
    [estimateNoteApi.reducerPath]: estimateNoteApi.reducer,
    [estimateCategoryApi.reducerPath]: estimateCategoryApi.reducer,
    [BuildModeApi.reducerPath]: BuildModeApi.reducer,
    [BuildStageApi.reducerPath]: BuildStageApi.reducer,
    [shopAdminApi.reducerPath]: shopAdminApi.reducer,
    [NotificationRules.reducerPath]: NotificationRules.reducer,
    [shopFloorDisplaySettingsApi.reducerPath]: shopFloorDisplaySettingsApi.reducer,
    [ShopAdminDasbhoardApi.reducerPath]: ShopAdminDasbhoardApi.reducer,
    [MessageBoard.reducerPath]: MessageBoard.reducer,
    [adminManagementApi.reducerPath]: adminManagementApi.reducer,
    [adminAiChatApi.reducerPath]: adminAiChatApi.reducer,
    user: persistedUserReducer, 
    aiMessages: persistedAiMessagesReducer,
    supportCounts: supportCountsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER','build-mode/executeQuery/fulfilled'],
        ignoredPaths: ['build-mode.queries'],
      },
    }).concat(
      // productsApi.middleware,
      FaqsApi.middleware,
      contactApi.middleware,
      customersApi.middleware,
      adminSettingsApi.middleware,
      adminSupportApi.middleware,
      usersApi.middleware,
      dashboardApi.middleware,  
      authApi.middleware, 
      fileApi.middleware,
      contractorAuthApi.middleware,
      languageApi.middleware,
      contractorDashboardApi.middleware,
      categoryApi.middleware,
      adminAuthApi.middleware,
      inventoryApi.middleware,
      settingsApi.middleware,
      technicianApi.middleware,
      estimatorTemplateApi.middleware,
      metricApi.middleware,
      ClientApi.middleware,
      adminAuthApi.middleware,
      courseCategoryApi.middleware,
      adminContractorsApi.middleware,
      jobTypeApi.middleware,  
      geographicAdjusterApi.middleware,
      adminServicesApi.middleware,
      additionalServicesApi.middleware, 
      adminTermsApi.middleware,
      invoiceApi.middleware,  
      transactionApi.middleware,
      jobsApi.middleware, 
      jobTypesApi.middleware,  
      reminderSettingsApi.middleware, 
      estimatorSettingApi.middleware,
      contractorSettingsApi.middleware,
      courseApi.middleware,
      lessonApi.middleware,
      supportCenterCategoryApi.middleware,
      resourceApi.middleware,
      resourcePackageApi.middleware,
      alertApi.middleware,
      invoiceNoteApi.middleware,
      aiAssistantApi.middleware,
      customizePagesApi.middleware,
      tilledApi.middleware,
      estimateNoteApi.middleware,
      estimateCategoryApi.middleware,
      BuildModeApi.middleware,
      BuildStageApi.middleware,
      shopAdminApi.middleware,
      NotificationRules.middleware,
      shopFloorDisplaySettingsApi.middleware,
      ShopAdminDasbhoardApi.middleware,
      MessageBoard.middleware,
      adminManagementApi.middleware,
      adminAiChatApi.middleware
    ),
});

// Initialize Redux Persist
export const persistor = persistStore(store);

// Setup listeners
setupListeners(store.dispatch);
